import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { Button } from '@mui/material';
import { FormattedMessage } from 'react-intl';

const LoginAzure = () => {
    const { instance } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const handleLogin = () => {
        instance.loginPopup();
    };
    const handleLogout = () => {
        instance.logout();
    };

    return isAuthenticated ? (
        <Button
            onClick={handleLogout}
            key="logoutPopup"
            variant="outlined"
            color="primary"
            fullWidth
        >
            <FormattedMessage id="logout" />
        </Button>
    ) : (
        <Button
            onClick={handleLogin}
            variant="outlined"
            color="primary"
            fullWidth
        >
            <FormattedMessage id="login" />
        </Button>
    );
};

export default LoginAzure;
